import { render, staticRenderFns } from "./CreateDistributor.vue?vue&type=template&id=0504d09a&"
import script from "./CreateDistributor.vue?vue&type=script&lang=js&"
export * from "./CreateDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports